import { Round } from "../models/round";
import { API_URL } from "./apiBase";

export async function RoundSubmit(
    url: string,
    accessToken: string,
    body?: Round,
    method: string = "POST"
) {
    const response = await fetch(url, {
        method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Failed to ${method} round`);
    }

    return response.json();
}



export async function deleteRound(
    project_id: string,
    round_id: string,
    accessToken: string
) {
    return RoundSubmit(
        `${API_URL}/projects/${project_id}/round/${round_id}`,
        accessToken,
        undefined,
        "DELETE"
    );
}
